import type { TranslationMessages } from '../../types';

export const point_earning: TranslationMessages = {
  title: 'Point Earning',
  subtitle: 'Complete tasks to earn points and unlock rewards',
  how_points_work: 'How Points Work',
  total_points: 'Total Points',
  points_earned_today: 'Points earned today',
  tasks_completed: 'Tasks Completed',
  tasks_completed_today: 'Tasks completed today',
  progress: 'Progress',
  daily_completion_rate: 'Daily completion rate',
  progress_label: 'Progress',
  points_label: 'pts',
  completed: 'Completed',
  complete_task: 'Complete Task',
  task_already_completed: 'Task already completed!',
  task_completed_message: 'Task completed! You earned %{points} points!',
  task_submitted_for_approval:
    'Task submitted for approval! Points will be awarded after manager verification.',
  requires_approval: 'Requires Approval',
  automatic: 'Automatic',
  approved: 'Approved',
  rejected: 'Rejected',
  pending_approval: 'Pending Approval',
  pending: 'Pending',
  approval_notice:
    'This task requires manager approval. Points will be awarded after verification.',
  automatic_notice: 'This task awards points automatically upon completion.',
  types_title: 'Types of Point Earning:',
  types_automatic_title: 'Automatic Points',
  types_automatic_description:
    'Points are awarded immediately when you complete the task. No approval needed - based on verifiable system data.',
  types_automatic_example_1: 'Early check-in (verified by system timestamp)',
  types_automatic_example_2: 'Daily sales targets (verified by sales data)',
  types_automatic_example_3:
    'Perfect attendance (verified by attendance records)',
  types_approval_title: 'Approval-Required Points',
  types_approval_description:
    'Points require manager verification before being awarded. Submit your completion and wait for approval.',
  types_approval_example_1:
    'Excellent customer service (requires verification of feedback)',
  types_approval_example_2:
    'Team collaboration (requires verification from colleagues)',
  types_approval_example_3:
    'Skill development (requires verification of training completion)',
  types_examples: 'Examples:',
  difficulty_easy: 'Easy',
  difficulty_medium: 'Medium',
  difficulty_hard: 'Hard',
  system_title: 'Neko Point System',
  system_description:
    'Earn points by completing daily tasks and achieving milestones. Points can be redeemed for rewards and recognition.',
  how_it_works: 'How It Works:',
  rule_complete_tasks: 'Complete tasks to earn points',
  rule_difficulty_based: 'Points are awarded based on task difficulty',
  rule_daily_reset: 'Daily tasks reset every 24 hours',
  rule_bonus_challenges:
    'Weekly and monthly challenges offer bonus points',
  rule_redeem: 'Points can be redeemed in the Point Store',
  benefits_title: 'Benefits:',
  benefit_redeem: 'Redeem points for rewards',
  benefit_badges: 'Unlock achievement badges',
  benefit_leaderboard: 'Climb the leaderboard rankings',
  benefit_recognition: 'Earn recognition from management',
  benefit_perks: 'Access exclusive perks and benefits',
  got_it: 'Got it!',
  how_to_complete: 'How to Complete:',
  close: 'Close',
  points: 'points',
};
